"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIPO_FORMULARIO = void 0;
var TIPO_FORMULARIO = exports.TIPO_FORMULARIO = {
  FORMIK: "FORMIK",
  TANSTACK: "TANSTACK"
};